import { useFeatureFlag } from '@spotify/confidence-core-react';

import { useIntercom } from './useIntercom';
import { useUnthread } from './useUnthread';

type SupportMessengerVariant = 'unthread' | 'fin';

type SupportMessengerFlag = { messenger: SupportMessengerVariant };

const DEFAULT_FLAG_VALUE: SupportMessengerFlag = { messenger: 'unthread' };

export interface SupportMessenger {
  openChat: (user?: { name: string; email: string }) => void;
  closeChat: () => void;
  toggleChat: () => void;
  variant: SupportMessengerVariant;
}

export const useSupportMessenger = (): SupportMessenger => {
  const { messenger } = useFeatureFlag<SupportMessengerFlag>(
    'support-messenger',
    DEFAULT_FLAG_VALUE,
  );

  const isUnthread = messenger === 'unthread';
  const isFin = messenger === 'fin';

  const unthread = useUnthread({ enabled: isUnthread });
  const intercom = useIntercom({ enabled: isFin });

  if (isUnthread) {
    return {
      openChat: unthread.openChat,
      closeChat: unthread.closeChat,
      toggleChat: unthread.toggleChat,
      variant: 'unthread',
    };
  }

  return {
    openChat: intercom.openChat,
    closeChat: intercom.closeChat,
    toggleChat: intercom.toggleChat,
    variant: 'fin',
  };
};
